const state = {
  collectionList: []
}
const getters = {
  getCollectionList (state) {
    return state.collectionList
  },
  getLOObjectByContentId: (state, getters) => contentId => {
    for (var i = 0; i < getters.getCollectionList.length; i++) {
      if (getters.getCollectionList[i].contentId === contentId) {
        return getters.getCollectionList[i]
      }
    }
  }

}

const mutations = {
  setCollectionList (state, data) {
    if (data !== null) {
      state.collectionList = data
    }
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/collection.js